import React, {useEffect} from 'react';
import './App.css';
import WebApp from '@twa-dev/sdk'
import {ChakraProvider, createSystem, defaultConfig, defineConfig, SystemContext} from "@chakra-ui/react";
import {BrowserRouter, Navigate, Route, Router, Routes} from "react-router-dom";
import SettingsPage from "./pages/settings/SettingsPage";
import HomePage from "./pages/home/HomePage";
import RemindersPage from "./pages/reminders/list/RemindersPage";
import LayoutWithLang from "./pages/lang/LayoutWithLang";
import EditReminderPage from "./pages/reminders/edit/EditReminderPage";
import NotesPage from "./pages/notes/list/NotesPage";
import CreateReminderPage from "./pages/reminders/create/CreateReminderPage";

WebApp.ready();
WebApp.expand();

function App() {


    useEffect(() => {
        const initData = WebApp?.initData;


        if (initData && initData.length > 0) {
            /*  alert(
                  JSON.stringify(WebApp?.initData)
              );*/
        }


        try {
            //WebApp.showAlert(JSON.stringify(WebApp?.initDataUnsafe?.user));
            // WebApp.showAlert(JSON.stringify(WebApp?.initData));
        } catch (e) {

        }

    }, [WebApp?.initData]);


    const sendRequest = () => {
        const initData = WebApp?.initData;
      console.warn(initData)

        fetch("/api/ai-notification/settings", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Telegram-InitData": initData ?? "",
            },
            body: JSON.stringify({action: "start_session"}),
        });
    }




    const config = defineConfig({
        theme: {
            tokens: {
                colors: {},
            },
        },
    })

    const system = createSystem(defaultConfig, config)


    return (
        <div className="App">
            <ChakraProvider value={system}>
                <BrowserRouter>
                    <Routes>
                        {/* Родительский маршрут с параметром языка */}
                        <Route path="/:lang" element={<LayoutWithLang />}>
                            <Route index element={<HomePage />} />
                            <Route path="settings" element={<SettingsPage />} />
                            <Route path="reminders" element={<RemindersPage />} />
                            <Route path="reminders/:id/edit" element={<EditReminderPage />} />
                            <Route path="reminders/create" element={<CreateReminderPage />} />
                            <Route path="notes" element={<NotesPage />} />
                            <Route path="notes/:id/edit" element={<SettingsPage />} />
                        </Route>

                        {/* Опционально: редирект с корня на язык по умолчанию */}
                        <Route path="/" element={<Navigate to="/en" replace />} />
                    </Routes>
                </BrowserRouter>
            </ChakraProvider>
        </div>
    );
}

export default App;
